import { getBase64 } from '@mews/framework';

export const handleImagePayload = async (
    image?: File[] | null
): Promise<{ name: string; type: string; data: string } | null> => {
    let imageValue = null;

    if (image && image?.length > 0) {
        const base64Image = await getBase64(image[0]);
        const { name, type } = image[0];

        imageValue = {
            name,
            type,
            data: base64Image,
        };
    }

    return imageValue;
};
